import React, { useEffect, useState } from 'react';
import { Box, Button, IconButton } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useNavBarStyles } from './NavBar.styles';
import NavDrawer from './NavDrawer';

const links = [
    { label: 'Services', href: '/services' },
    { label: 'Work', href: '/work' },
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' },
];

const NavBar = () => {
    const { classes, cx } = useNavBarStyles();
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const textColor = scrolled ? '#111111' : '#F5F5F2';

    return (
        <>
            <Box
                component="nav"
                className={cx(classes.appBar, scrolled && classes.appBarSolid)}
                sx={{ color: textColor }}
            >
                <Box className={classes.toolbar}>
                    <Box
                        className={classes.logo}
                        onClick={() => navigate('/')}
                    >
                        Nexora
                    </Box>

                    <Box className={classes.desktopNav}>
                        {links.map((link) => (
                            <Link key={link.label} to={link.href} className={classes.navLink}>
                                {link.label}
                            </Link>
                        ))}
                    </Box>

                    <Button
                        variant="outlined"
                        component={Link}
                        to="/contact"
                        className={classes.ctaButton}
                        sx={{ borderColor: scrolled ? 'divider' : 'rgba(245,245,242,0.35)', color: textColor }}
                    >
                        Start a project
                    </Button>

                    <IconButton
                        aria-label="open menu"
                        className={classes.menuButton}
                        onClick={() => setDrawerOpen(true)}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', width: 22 }}>
                            <Box sx={{ height: '1.5px', backgroundColor: textColor, width: '100%' }} />
                            <Box sx={{ height: '1.5px', backgroundColor: textColor, width: '70%' }} />
                        </Box>
                    </IconButton>
                </Box>
            </Box>

            <NavDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} links={links} />
        </>
    );
};

export default NavBar;
